__webpack_require__.p = "https://icd.prachay.com/";